export default {
  unbindAlipay: '/courier/api/financial/aliPayOauthAbort'
}
